import { Component, Input, OnInit } from '@angular/core';
import { SignatureDTO, FileDetailsDTO, DocumentEnvelopeDTO } from '../../api/plyca-dtos';
import { DocumentService } from '../../documents/document.service';
import { EnvelopeDocumentDTO } from '../../api/plyca-dtos-v2';

@Component({
  selector: 'tenderDocumentDetail',
  templateUrl: 'tenderDocumentDetail.template.html'
})
export class TenderDocumentDetailComponent implements OnInit {

  // Ofertas v2
  @Input()
  documentV2: EnvelopeDocumentDTO;
  // Ofertas v1
  @Input()
  documentV1: DocumentEnvelopeDTO;

  public documentName: string;
  public file: FileDetailsDTO;

  constructor(protected documentService: DocumentService) {
  }
  ngOnInit(): void {
    if (this.documentV2) {
      this.documentName = this.documentV2.documentName;
      this.file = this.documentV2.documentFile;
    } else if (this.documentV1) {
      this.documentName = this.documentV1.nameDocument;
      this.file = this.documentV1.file;
    }
  }


  public isValidSignature(signature: SignatureDTO): boolean {
    return SignatureDTO.isValidSignature(signature);
  }

  public validateSignDocument(
    signature: SignatureDTO,
    fileItem: FileDetailsDTO
  ) {
    console.log('Método validateSignDocument');
    this.documentService.validateSignDocument(signature, fileItem);
  }

  public signatures(fileDetails: FileDetailsDTO): Array<SignatureDTO> {
    return SignatureDTO.getSignatures(fileDetails);
  }

}